const permissionsMap = {
botsListing: 'bot.view.bot.get',
conversations: 'test_conversation.view.clients.get',
addFaq: 'es.view.es.faq.list',
trainBot: 'nlu_training_data.view.examples.list'
};

export default permissionsMap;